import { render, staticRenderFns } from "./PosDatabaseRecovery.vue?vue&type=template&id=e18adb64&scoped=true&"
import script from "./PosDatabaseRecovery.vue?vue&type=script&lang=js&"
export * from "./PosDatabaseRecovery.vue?vue&type=script&lang=js&"
import style0 from "./PosDatabaseRecovery.vue?vue&type=style&index=0&id=e18adb64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e18adb64",
  null
  
)

export default component.exports